module.exports = __webpack_public_path__ + "img/canfite.a2b06468.png";